import { render } from "./search-mobile-header.vue?vue&type=template&id=72497ff4"
import script from "./search-mobile-header.vue?vue&type=script&lang=js"
export * from "./search-mobile-header.vue?vue&type=script&lang=js"

import "./search-mobile-header.vue?vue&type=style&index=0&id=72497ff4&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__